import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';

interface StyledButtonRemoveProps {
	disabled?: boolean;
}

const StyledButtonRemove = styled('button')`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	border: 2px solid ${NewStyleColor.White};
	border-radius: 50%;
	background-color: transparent;
	color: ${NewStyleColor.White};
	outline: 0;
	cursor: pointer;

	${({ disabled }: StyledButtonRemoveProps) => disabled && `
		cursor: default;
		opacity: 0.5;
	`}

	&:hover {
		opacity: 0.8;
	}

	svg {
		width: 8px;
		height: 8px;
		fill: currentColor;
	}
`;

export { StyledButtonRemove };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ButtonRemove/styles.ts